const Tooltip = {
   baseStyle: {
      fontSize: '1rem',
   },
   defaultProps: {
      openDelay: 50,
      shouldWrapChildren: true,
      closeOnMouseDown: true,
   },
};

export default Tooltip;
